// removed by extract-text-webpack-plugin
module.exports = {"courseSummary":"_LvkYXUkMZQ1_lmQ0j_YR","courseItem":"_1Ys6jwAY6OJJd6zrWaSScA","btn":"_1TiSu9PeD2yKaGsAxLoAu0","btnDisabled":"_1M-acFnu7HNlg40A1VJyJC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/CourseOverview.css
// module id = 1316
// module chunks = 0